// src/components/UpdateNotification.js
import React, { useState, useEffect } from 'react';

const UPDATE_MSG_KEY = 'hideUpdateMsg-20260305'; // 날짜나 버전 바꿀 때 이 값만 변경

export default function UpdateNotification() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem(UPDATE_MSG_KEY)) {
      setShow(true);
    }
  }, []);

  function handleClose() {
    window.localStorage.setItem(UPDATE_MSG_KEY, 'true');
    setShow(false);
  }

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 2000,
      background: '#FFE8A3',
      color: '#222',
      padding: '18px 0 14px 0',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 18,
      boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
    }}>
      <div>
        {/* 27.11.2025 New Event Released!<br />Check the event button. */}
        05.03.2026 Update completed.<br />Please check the announcements.
      </div>
      <button
        onClick={handleClose}
        style={{
          marginTop: 13,
          padding: '5px 18px',
          background: '#fffbe6',
          color: '#B49000',
          border: '1px solid #FED352',
          borderRadius: 8,
          fontWeight: 500,
          fontSize: 15,
          cursor: 'pointer'
        }}>
        Don't show again
      </button>
    </div>
  );
}
